import React from "react";

import { Box, Grid, Typography } from "@material-ui/core";

import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const MapsInfoLabel = ({ children }) => (
    <Box color="primary.label" fontSize={16}>
        {children}
    </Box>
)

const MapsInfoValue = ({ children }) => (
    <Box color="primary.main" fontSize={16} marginTop={2}>
        {children}
    </Box>
)

export default function GoogleMapsComponent({ address }) {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "",
    });
    const [isReady, setIsReady] = React.useState(false);

    const [map, setMap] = React.useState(null);
    const [center, setCenter] = React.useState(null);
    const [marker, setMarker] = React.useState(null);
    const [endereco, setEndereco] = React.useState({});
    const [errorMessage, setErrorMessage] = React.useState(null);

    const onLoad = React.useCallback(function callback(map) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, function (results, status) {
            if (status == "OK") {
                const location = results[0].geometry.location;
                const center = { lat: location.lat(), lng: location.lng() };
                const address = results[0].address_components;

                const numero = address.filter(a => a.types.includes("street_number"))[0]?.short_name ?? "não encontrado";
                const rua = address.filter(a => a.types.includes("route"))[0]?.short_name ?? "não encontrado";
                const bairro = address.filter(a => a.types.includes("sublocality_level_1"))[0]?.short_name ?? "não encontrado";
                const cidade = address.filter(a => a.types.includes("administrative_area_level_2"))[0]?.short_name ?? "não encontrado";
                const estado = address.filter(a => a.types.includes("administrative_area_level_1"))[0]?.short_name ?? "não encontrado";
                const cep = address.filter(a => a.types.includes("postal_code"))[0]?.short_name ?? "não encontrado";

                setEndereco({
                    numero,
                    rua,
                    bairro,
                    cidade,
                    estado,
                    cep,
                });
                setMap(map);
                setCenter(center);
                setMarker(center);
                setIsReady(true);

            }else if (status === "ZERO_RESULTS") {
                    console.warn("Geocode was not successful for the following reason: " + status);
                    const defaultCenter = { lat: -14.2350, lng: -51.9253 }; // Coordenadas do centro do Brasil
                    setCenter(defaultCenter);
                    setMarker(defaultCenter);
                    setIsReady(false);
                    setErrorMessage("Esta página não carregou o Google Maps corretamente.");
            } else {
                console.warn("Geocode was not successful for the following reason: " + status);
            }
        });
    }, []);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
        setCenter(null);
        setMarker(null);
        setIsReady(false);
    }, []);

    return isLoaded ? (
        <Grid container style={{ backgroundColor: "#fff", "padding": 20 }} direction="column">
            {isReady ? (<Grid item style={{ height: 200 }}>
                <Grid container >
                    <Grid item>
                        <MapsInfoLabel>
                            Endereço
                        </MapsInfoLabel>
                        <MapsInfoValue>
                            {`${endereco.rua}, ${endereco.numero}`}
                        </MapsInfoValue>
                    </Grid>
                </Grid>
                <Grid container style={{ "marginTop": 20 }}>
                    <Grid item md={6}>
                        <MapsInfoLabel>
                            CEP
                        </MapsInfoLabel>
                        <MapsInfoValue>
                            {endereco.cep}
                        </MapsInfoValue>
                    </Grid>
                    <Grid item md={6}>
                        <MapsInfoLabel>
                            UF
                        </MapsInfoLabel>
                        <MapsInfoValue>
                            {endereco.estado}
                        </MapsInfoValue>
                    </Grid>
                </Grid>
                <Grid container style={{ "marginTop": 20 }}>
                    <Grid item md={6}>
                        <MapsInfoLabel>
                            Bairro
                        </MapsInfoLabel>
                        <MapsInfoValue>
                            {endereco.bairro}
                        </MapsInfoValue>
                    </Grid>
                    <Grid item md={6}>
                        <MapsInfoLabel>
                            Cidade
                        </MapsInfoLabel>
                        <MapsInfoValue>
                            {endereco.cidade}
                        </MapsInfoValue>
                    </Grid>
                </Grid>
            </Grid>) : <>{"Buscando localização"}</>}
            <Grid item >
                <GoogleMap
                    mapContainerStyle={{
                        width: "100%",
                        height: "200px",
                        position: "relative",
                    }}
                    center={center}
                    zoom={15}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    <Marker position={marker} />
                    {errorMessage && (
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'white',
                            padding: '10px',
                            borderRadius: '5px',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                            textAlign: 'center'
                        }}>
                            {errorMessage}
                        </div>
                    )}
                </GoogleMap>
            </Grid>
        </Grid >
    ) : (
        <>{"Buscando localização"}</>
    );
};
